import 'pixi-particles';

import Utils from '../lib/utils';
import Audio from '../lib/audio';
import OutlineFilter from '../lib/OutlineFilter';

const audios = {
    pump: new Audio('/audio/piston1.mp3'),
    pump2: new Audio('/audio/piston2.mp3'),
};

let loud = false;

module.exports = {
    createParticlesEmitter: (container, texture, opts) => {
        const outlineFilter = new OutlineFilter(window.innerWidth, window.innerHeight, 1, 0xFFFFFF);
        container.filters = [outlineFilter];

        return new PIXI.particles.Emitter(container, texture, _.extend({
            emit: false,
            alpha: {
                start: 1,
                end: 1
            },
            scale: {
                start: 0.3,
                end: 0.5
            },
            color: {
                start: '#000000',
                end: '#000000',
            },
            speed: {
                start: 600,
                end: 200
            },
            acceleration: {
                x: 0,
                y: 3000
            },
            lifetime: {
                min: 1,
                max: 1
            },
            frequency: 0.014,
            emitterLifetime: -1,
            maxParticles: 1000,
            pos: {
                x: 0,
                y: 0
            },
            spawnType: 'point',
            spawnPos: {
                x: 0,
                y: 0
            }
        }, opts));
    },

    emitParticles: function(movieclip, particlesEmitter, particles, particlesFrames, opts)
    {
        opts = _.extend({
            playAudio: false
        }, opts);

        particles.x = movieclip.x;
        particles.y = movieclip.y;

        var currentFrame = movieclip.currentFrame;
        var lastFrame = currentFrame === 0 ? movieclip.totalFrames-1:currentFrame - 1;
        var particlesLastFrame =  _.get(particlesFrames, lastFrame, {x: 0, y: 0, emit: false});
        var particlesFrame = _.get(particlesFrames, currentFrame, {x: 0, y: 0, emit: false});
        var spawnX = movieclip.width * Utils.getValueInPixels(particlesFrame.x);
        var spawnY = movieclip.height * Utils.getValueInPixels(particlesFrame.y);
        var lastEmit = particlesLastFrame.emit;
        var emit = particlesFrame.emit;
        var spawnAngle = _.get(particlesFrame, 'angle', 310);

        particlesEmitter.minStartRotation = spawnAngle - 10;
        particlesEmitter.maxStartRotation = spawnAngle + 10;
        particlesEmitter.spawnPos = new PIXI.Point(spawnX, spawnY);
        particlesEmitter.emit = emit;

        if (emit && !lastEmit && opts.playAudio)
        {
            if (loud) {
                audios.pump.play();
            } else {
                audios.pump2.play();
            }
            loud = !loud;
        }
    },
};



// WEBPACK FOOTER //
// ./js/animations/pumpers.js